import { Component, OnInit } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { DetailsService } from '../../services/details.service';
import { IDetailType, IInventoryMasterDetail, IFoodType, IFoodSize, IFeedingLineItemDetail,
         IFecalAppearance, IShedType, IHealthIncidentType, IFecalLineItemDetail, IShedLineItemDetail,
         IHealthLineItemDetail, IGrowthLineItemDetail, IFeedingOutcome, IFeedingType, IDetailLineItem, IViewDetailLineItem } from '../../interfaces/';
import { DetailType, FeedingLineItemDetail, FecalLineItemDetail, ShedLineItemDetail, HealthLineItemDetail,
         GrowthLineItemDetail, DetailLineItem, ViewDetailLineItem } from '../../models/';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

enum detailTypeEnums {
	feeding = 1,
	defecation = 2,
	shed = 3,
	growth = 4,
	health = 5,
	genetic = 6,
	additionalNote = 7
}

@Component({
  selector: 'add-details',
  templateUrl: './add-details.component.html',
  styleUrls: ['./add-details.component.css']
})
export class AddDetailsComponent implements OnInit {

	public inventory: IInventoryMasterDetail[] = [];
	public detailTypes: IDetailType[] =[];
	public foodTypes: IFoodType[] = [];
	public foodSizes: IFoodSize[] = [];
	public feedTypes: IFeedingType[] = [];
	public feedResultTypes: IFeedingOutcome[] = [];
	public defecationTypes: IFecalAppearance[] = [];
	public shedTypes: IShedType[] = [];
	public incidentTypes: IHealthIncidentType[] = [];	
  public masterRecord: IInventoryMasterDetail;
	public genders: any[] = [];

  selectedMasterId: number = 0;
	selectedDetailType: any;
  message = "";
  groupId: number = 0;
	public feedDateValue:Date = new Date();
	public defecationDateValue:Date = new Date();
	public shedDateValue:Date = new Date();
	public growthDateValue:Date = new Date();
	public incidentDateValue: Date = new Date();
	public additionalNoteDateValue: Date = new Date();
	public hatchDateValue: Date = new Date();
	public soakAssist:boolean = false;
	public internalInventory:boolean = false;
	public saleInventory:boolean = false;
	public loanInventory:boolean = false;

  saveSuccess: boolean;
  isAuthenticated: boolean = false;
  feedingDetail: IFeedingLineItemDetail = new FeedingLineItemDetail();
  fecalDetail: IFecalLineItemDetail = new FecalLineItemDetail();
  growthDetail: IGrowthLineItemDetail = new GrowthLineItemDetail();
  healthDetail: IHealthLineItemDetail = new HealthLineItemDetail();
  shedDetail: IShedLineItemDetail = new ShedLineItemDetail();

  constructor(private detailsService: DetailsService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    
    if(this.route.snapshot.paramMap.get('grp')){
      this.groupId = parseInt(this.route.snapshot.paramMap.get('grp'));
    }
    else{
      if(sessionStorage.getItem("token")){
          let obj = JSON.parse(sessionStorage.getItem("token"));
          if(obj && obj.Token != ""){
            this.isAuthenticated = true;
          }
      }
      else {
        this.router.navigate(['/login']);
      }
    }

    if(this.route.snapshot.paramMap.get('id')){
      this.selectedMasterId = parseInt(this.route.snapshot.paramMap.get('id'));
    }
    else {
      this.selectedMasterId = 0;  
    }

    if(sessionStorage.getItem("groupId")){
      let group = JSON.parse(sessionStorage.getItem("groupId"));
      if(group && group.GroupId != 0){
          this.groupId = group.GroupId;
      }
    }
    this.loadInventoryList();  	
  	this.loadDetailTypeList();

  }

  eventlog()
  {
    //console.log(this.selectedDetailType);
  }

  loadLastRecordForType(){
    if(this.selectedMasterId && this.selectedMasterId != 0 && 
      this.selectedDetailType && this.selectedDetailType != 0){
        let latestDetail: IViewDetailLineItem = new ViewDetailLineItem();
        latestDetail.DetailTypeId = this.selectedDetailType;
        latestDetail.MasterDetailId = this.selectedMasterId;

        if(this.selectedDetailType == 1){
            this.detailsService.getMasterDetailRecordById(this.selectedMasterId).subscribe(
              masterRecord => {
                this.masterRecord = masterRecord;
            //this.loadFoodTypeList();
            this.loadFoodTypeListByType(this.masterRecord.InventoryTypeId);
            this.loadFoodSizeList();
            this.loadFeedingTypeList();
            this.loadFeedResultList();
            this.detailsService.getLatestFeedLineItemDetail(latestDetail).subscribe(
              resp => {
                if(resp == null || resp.Id == null || resp.Id == 0){
                  this.feedingDetail = new FeedingLineItemDetail();
                  this.feedingDetail.FoodTypeId = 0;
                  this.feedingDetail.FoodSizeId = 0;
                  this.feedingDetail.FeedingType = 0;
                  this.feedingDetail.Outcome = 0;
                }
                else{
                  this.feedingDetail = resp;
                }
              }
            );
          });
        }
        else if(this.selectedDetailType == 2){
          this.loadDefecationTypeList();
          this.detailsService.getLatestFecalLineItemDetail(latestDetail).subscribe(
              resp => {
                if(resp == null || resp.Id == null || resp.Id == 0){
                  this.fecalDetail = new FecalLineItemDetail();
                  this.fecalDetail.Appearance = 0;
                }
                else{
                  this.fecalDetail = resp;
                }
              }
            );   
        }
        else if(this.selectedDetailType == 3){        
            this.loadShedTypeList();
            this.detailsService.getLatestShedLineItemDetail(latestDetail).subscribe(
              resp => {
                if(resp == null || resp.Id == null || resp.Id == 0){
                  this.shedDetail = new ShedLineItemDetail();
                  this.shedDetail.ShedType = 0;
                }
                else{
                  this.shedDetail = resp;
                }
              }
            );
        }
        else if(this.selectedDetailType == 4){
            this.detailsService.getLatestGrowthLineItemDetail(latestDetail).subscribe(
              resp => {
                if(resp == null || resp.Id == null || resp.Id == 0){
                  this.growthDetail = new GrowthLineItemDetail();
                }
                else{
                  this.growthDetail = resp;
                }
              }
            );
        }
        else if(this.selectedDetailType == 5){
          this.loadIncidentTypeList();
            this.detailsService.getLatestHealthLineItemDetail(latestDetail).subscribe(
              resp => {
                if(resp == null || resp.Id == null || resp.Id == 0){
                  this.healthDetail = new HealthLineItemDetail();
                  this.healthDetail.IncidentType = 0;
                }
                else{
                  this.healthDetail = resp;
                }
              }
            );
        }
        else if(this.selectedDetailType == 6){
             
        }
        else if(this.selectedDetailType == 7){

        }
    }
  }

  loadInventoryList(){
    this.inventory = [];
    this.detailsService.getMasterDetailRecords(this.groupId).subscribe(
      resp => {
      this.inventory = resp;
    });
  }

  loadDetailTypeList(){
    this.detailTypes = [];
    this.detailsService.getDetailTypes().subscribe(
      resp => {
      this.detailTypes = resp;
    });
  }

  loadFoodTypeList(){
    this.foodTypes = [];
    this.detailsService.getFoodTypes().subscribe(
      resp => {
      this.foodTypes = resp;
    });  
  }

  loadFoodTypeListByType(inventoryTypeId: number){
    this.foodTypes = [];
    this.detailsService.getFoodTypesByInventoryType(inventoryTypeId).subscribe(
      resp => {
      this.foodTypes = resp;
    });  
  }

  loadFoodSizeList(){
  	this.foodSizes = [];
    this.detailsService.getFoodSizes().subscribe(
      resp => {
      this.foodSizes = resp;
    });  
  }

  loadFeedingTypeList(){
    this.detailsService.getFeedingTypes().subscribe(
            types => {
            this.feedTypes = types;
      });
  }

  loadFeedResultList(){
    this.detailsService.getFeedingOutcomes().subscribe(
            outcomes => {
            this.feedResultTypes = outcomes;
      });
  }

  loadDefecationTypeList(){
    this.defecationTypes = [];
    this.detailsService.getDefecationAppearances().subscribe(
      resp => {
      this.defecationTypes = resp;
    }); 
  }
  loadShedTypeList(){
    this.shedTypes = [];
    this.detailsService.getShedTypes().subscribe(
      resp => {
      this.shedTypes = resp;
    });
  }

  loadIncidentTypeList(){

    this.incidentTypes = [];
    this.detailsService.getHealthIncidentTypes().subscribe(
      resp => {
      this.incidentTypes = resp;
    });
  }

  saveDetail(){
    this.message = "";
    if(this.selectedDetailType && this.selectedMasterId){
      let detailLineItem: IViewDetailLineItem = new ViewDetailLineItem();
        detailLineItem.DetailTypeId = this.selectedDetailType;
        detailLineItem.MasterDetailId = this.selectedMasterId;
      if(this.selectedDetailType == 2){
        detailLineItem.LineItemDate = this.defecationDateValue;
        detailLineItem.fecalLine = this.fecalDetail;        
      }
      else if(this.selectedDetailType == 1){
        detailLineItem.LineItemDate = this.feedDateValue;
        detailLineItem.feedingLine = this.feedingDetail;
      }
      else if(this.selectedDetailType == 3){        
        detailLineItem.LineItemDate = this.shedDateValue;
        detailLineItem.shedLine = this.shedDetail;
      }
      else if(this.selectedDetailType == 4){
        detailLineItem.LineItemDate = this.growthDateValue;
        detailLineItem.growthLine = this.growthDetail;
      }
      else if(this.selectedDetailType == 5){
        detailLineItem.LineItemDate = this.incidentDateValue;
        detailLineItem.healthLine = this.healthDetail;
      }
      else if(this.selectedDetailType == 6){
         
      }
      else if(this.selectedDetailType == 7){

      }


      //types 6 & 7 not yet implemented
      if(this.selectedDetailType != 6 && this.selectedDetailType != 7){
        this.saveSuccess = false;
        this.message = "Saving record";

        this.detailsService.createLineItemDetailRecord(detailLineItem).subscribe(
          resp => {
            this.saveSuccess = resp;

            let type = this.detailTypes.find(t => t.Id == this.selectedDetailType);
            if(type){
              this.message = "Successfully saved " + type.Name + " detail record for "+ this.masterRecord.AnimalName + "/"+ this.masterRecord.AnimalID + ".";
            }
            else{
              this.message = "Successfully saved detail record for "+ this.masterRecord.AnimalName + "/"+ this.masterRecord.AnimalID + "."
            }
        });
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/inventory-manager/add-details/add-details.component.ts